import React from "react";
import PropTypes from 'prop-types';
import { ProgressSurveyAnswer, ProgressSurveyQuestion } from '../utils/types';
import SortableTable from "../SF/table/SortableTable";

export default class ProgressSurveyTable extends React.Component {

  get headers() {
    return this.props.isMobile
      ? [{content: 'Name'}, {content: 'Feedback'}]
      : [{content: 'Name'}].concat(
        this.props.surveyQuestions
          .filter(({type}) => type !== "default")
          .map(surveyQuestion => ({content: surveyQuestion.name, textAlign: "center"}))
      );
  }

  componentDidUpdate() {
    this.props.rebindStudentCards();
  }

  render() {
    return (
      <React.Fragment>
        <SortableTable
          columnToSort={'name'}
          headers={this.headers}
          itemName={"Students"}
          items={this.props.surveyAnswers}
          renderItem={this.props.renderStudent.bind(this, this.props.isMobile)}
          shouldPaginate={false}
          totalItems={this.props.surveyAnswers.length}
          fixed
        />
        <div>
          Showing {this.props.surveyAnswers.length} students
        </div>
      </React.Fragment>
    );
  }
}

ProgressSurveyTable.propTypes = {
  surveyAnswers: PropTypes.arrayOf(ProgressSurveyAnswer),
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  rebindStudentCards: PropTypes.func.isRequired,
  renderStudent: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
